import {AfterViewInit, Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {faBagShopping, faBell, faRightFromBracket, faUser} from "@fortawesome/pro-solid-svg-icons";
import {Router, RouterLink} from "@angular/router";
import {AuthService} from "../../../../../services/auth/auth.service";
import {MatDialog, MatDialogContent} from "@angular/material/dialog";
import {StateConfigService} from "../../../../../services/state/state-config.service";
import {ProjectControllerService, StateControllerService} from '../../../../../api';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {CdkConnectedOverlay, CdkOverlayOrigin} from "@angular/cdk/overlay";
import {CloudNumberComponent} from "../../cloud-number/cloud-number.component";
import {MatCard} from "@angular/material/card";
import {MatTooltip} from "@angular/material/tooltip";
import {KeyValuePipe} from "@angular/common";
import {TooltipDirective} from "@buildinginformationcloud/bic-ui-components";
import {VersionHistoryService} from "../../../../../services/version-history/version-history.service";


@Component({
  selector: 'app-sidebar-footer',
  templateUrl: './sidebar-footer.component.html',
  styleUrls: ['./sidebar-footer.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FaIconComponent,
    CdkOverlayOrigin,
    CloudNumberComponent,
    CdkConnectedOverlay,
    MatCard,
    MatTooltip,
    KeyValuePipe,
    RouterLink,
    MatDialogContent,
    TooltipDirective,

  ]
})
export class SidebarFooterComponent implements AfterViewInit, OnInit {
  authService = inject(AuthService);
  dialog = inject(MatDialog);
  projectControllerService = inject(ProjectControllerService);
  stateConfigService = inject(StateConfigService);
  private stateControllerService = inject(StateControllerService);
  private router = inject(Router);
  hasUnseenVersion = false;


  showAnalysisMenu = false;
  selectedButton: string = '';
  protected readonly faBell = faBell;
  private versionHistoryService = inject(VersionHistoryService);

  ngOnInit(): void {
    this.versionHistoryService.getEntries().subscribe({
      next: entries => {
        if (entries.length === 0) {
          return;
        }
        this.hasUnseenVersion = localStorage.getItem('lastSeenVersion') !== entries[0].version;
      },
      error: () => {
      }
    });
  }

  ngAfterViewInit() {

    document.querySelectorAll('.tooltip-fix').forEach(btn => {

      btn.addEventListener('mouseenter', () => {

        setTimeout(() => {

          const tip = document.querySelector('bic-tooltip div') as HTMLElement;

          if (!tip) return;

          const r = (btn as HTMLElement).getBoundingClientRect();

          tip.style.left =
            `${r.left + r.width / 2 - tip.offsetWidth / 2}px`;

        }, 0);

      });

    });

  }

  protected readonly faUser = faUser;
  protected readonly faBagShopping = faBagShopping;
  protected readonly faRightFromBracket = faRightFromBracket;

  performRouteLink(routeName: string){
        switch(routeName) {
          case "checkout":
            this.router.navigateByUrl('/checkout')
            break;
          case "profile":
            this.router.navigateByUrl('/profile')
            break;
          case "whats-new":
            this.hasUnseenVersion = false;
            this.router.navigateByUrl('/whats-new')
            break;
          case "logout":
            this.authService.logout();
            this.router.navigateByUrl('login')
            break;
        }
  }
}
